<template>
  <m-card-item
    icon="mail"
    hide-border
    @click="confirmInviteMail"
  >
    {{ $t('userListCard.sendInvitationMail') }}
  </m-card-item>
</template>

<script setup>
import useConfirmDialog from '@/composables/confirm-dialog';
import useInvitations from '@/composables/user/invitations/invitations';
import useSnackBar from '@/composables/snackbar';
import { logCatch } from '@/lib/logger/logger';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  user: {
    type: Object,
    required: true,
  },
});

const snackbar = useSnackBar();
const confirmDialog = useConfirmDialog();
const { t } = useI18n();
const { inviteUser } = useInvitations();

const confirmInviteMail = () => {
  const send = () => inviteUser(props.user).then(() => {
    snackbar.success(t('userListCard.invitationSuccess'));
  }).catch(logCatch(() => {
    snackbar.error();
  }));

  confirmDialog.confirm({
    title: t('userListCard.sendInvitationMailConfirm', {
      firstname: props.user.firstName,
      lastname: props.user.lastName,
    }),
    okText: t('general.send'),
    cancelText: t('general.cancel'),
    maskClosable: true,
    onOk() {
      send();
    },
  });
};
</script>
